module.exports = {
  path: "soil_moisture_history",
  getComponent(nextState, cb) {
    require.ensure([], require => {
      cb(null, require("./SoilMoisture"));
    });
  }
};



// WEBPACK FOOTER //
// ./src/routes/SoilMoisture/index.js